/* eslint-disable max-len */
import React, { useContext, useRef } from 'react';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import GlobalContext from "../../components/Context/GloablContext";

export default function CommonModal({
    children,
    message,
    title,
    show,
    handleClose,
    dialogueWidth,
    dialogueHeight,
    dialogTopOffset = 0
}) {
    const outsideClickRef = useRef();
    const { isSideNavBar } = useContext(GlobalContext);
    const dialogLeftOffset = 0;//!isSideNavBar ? 150 : 0;

    useOnClickOutside(outsideClickRef, () => {
        handleClose();
    });

    if (!show) {
        return null;
    }

    return (
        <div
            key={show}
            data-te-modal-init=""
            className="fixed inset-0 z-[1055] flex items-center justify-center overflow-y-auto overflow-x-hidden bg-[#00000047] p-4 outline-none"
            id="modalforDeactivate"
            tabIndex="-1"
            aria-labelledby="modalforDeactivateTitle"
            aria-modal="true"
            role="dialog"
            data-te-open="true"
        >
            <div
                ref={outsideClickRef}
                data-te-modal-dialog-ref=""
                className={"relative flex w-full items-center opacity-100 transition-all duration-300 ease-in-out " + (dialogueWidth ? '' : 'max-w-[415px]')}
                style={{
                    ...(dialogueWidth ? { width: dialogueWidth, maxWidth: '100%' } : {}),
                    transform: `translate(${dialogLeftOffset}px, ${dialogTopOffset}px)`
                }}
            >
                <div className="pointer-events-auto relative flex flex-col rounded-lg border-none bg-white bg-clip-padding shadow-s5 outline-none dark:bg-neutral-600" style={dialogueHeight ? { minHeight: dialogueHeight, maxHeight: dialogueHeight } : {}}>
                    <div className="flex items-center justify-between rounded-t-lg bg-[rgb(241,247,254)] px-3 py-2 mb-4">
                        <span className="text-lg font-semibold text-[#031624]">{title}</span>
                        <button
                            onClick={() => handleClose()}
                            type="button"
                            className="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                            data-te-modal-dismiss=""
                            aria-label="Close"
                        >
                            <img loading="lazy" decoding="async" src="/images/modalClose.svg" alt="icon" />
                        </button>
                    </div>
                    {message && <div className="mb-2"><p className="opacity-60 hover:opacity-80 focus:opacity-100 focus:shadow-none focus:outline-none">{message}</p></div>}
                    {children}
                </div>
            </div>
        </div>
    );
}
